// extracted by mini-css-extract-plugin
module.exports = {"modal":"nA","container":"nB","actions":"nC","button":"nD","text":"nE"};